import { mergeClasses } from "@fluentui/react-components";
import { useHelpMessageStyles } from "../styles/HelpMessage.styles";

export const HelpMessage = () => {
  const styles = useHelpMessageStyles();
  return (
    <div
      className={mergeClasses(styles.flexColumnStyle, styles.fullWidth, styles.flexCentered, styles.footNoteContainer)}
    >
      <div>
        <span className={styles.footNote}>Need help or forgot your password?</span>
      </div>
      <div>
        <span className={styles.footNote}>Please contact your system administrator.</span>
      </div>
    </div>
  );
};
